// import { createRouter, createWebHashHistory } from 'vue-router';
// import { XProgress } from '@/components';
// import {
//     globalRoutes,
//     userRoutes,
//     enterpriseRoutes,
//     matchAllRoute,
//     notFoundAndPermRoutes,
// } from './routes.js';
//
// const router = createRouter({
//     history: createWebHashHistory(process.env.VUE_APP_BASE_URL),
//     routes: [
//         ...globalRoutes,
//         matchAllRoute,
//         ...notFoundAndPermRoutes,
//     ],
// });
//
// router.beforeEach((to, from, next) => {
//     XProgress.start();
//     next();
// });
//
// router.afterEach(() => {
//     XProgress.done();
// });
//
// export const setRoutes = (routes = []) => {
//     router.clearRoutes();
//     for (const r of routes) {
//         router.addRoute(r);
//     }
// };
//
// export const resetRouter = () => {
//     const newRoutes = [ ...globalRoutes, matchAllRoute ];
//     setRoutes(newRoutes);
// };
//
// export const updateRouterByRole = (role = 'user') => {
//     let routes;
//     if (role === 'user') {
//         routes = [ ...globalRoutes, ...userRoutes, matchAllRoute, ...notFoundAndPermRoutes ];
//     } else if (role === 'org') {
//         routes = [ ...globalRoutes, ...enterpriseRoutes, matchAllRoute, ...notFoundAndPermRoutes ];
//     }
//     setRoutes(routes);
// };

import {
    AppRouter,
    permissionGuard,
    progressGuard,
} from '@/router';

import {
    staticRoutes,
    freeUserRoutes,
    consultantUserRoutes,
    budgetUserRoutes,
    financeUserRoutes,
} from './routes/index.js';

const menuConfig = {
    sorts: [ '首页', '账号', '系统设置', '绩效全过程', '绩效申报表管理', '绩效学习' ],
    expanded: [ '绩效全过程', '绩效申报表管理' ],
};

const setRoleRoutes = async (appRouter, userId, roles) => {
    const roleSet = new Set(roles);
    let routeMetas = [];
    if (userId) {
        if (roleSet.has('company-user') || roleSet.has('consultant-user')) {
            routeMetas = consultantUserRoutes;
        } else if (roleSet.has('finance-user')) {
            routeMetas = financeUserRoutes;
        } else if (roleSet.has('budget-user')) {
            routeMetas = budgetUserRoutes;
        } else {
            routeMetas = freeUserRoutes;
        }
    } else {
        routeMetas = staticRoutes;
    }
    appRouter.setRoutes(routeMetas);
    console.log('===>>> setRoleRoutes.');
    return true;
};
const appRouter = new AppRouter('kpi', staticRoutes, menuConfig, setRoleRoutes);

appRouter.useGuard(progressGuard, permissionGuard);

export const router = appRouter.router;
